import React, { useState, useRef, useEffect } from "react";
import { NavLink, useNavigate, useLocation, matchPath } from "react-router-dom";
import '../../App.css';
import { HiMenu } from "react-icons/hi";
import { IoMdSettings } from "react-icons/io";
import { RiLogoutCircleRLine } from "react-icons/ri";
import { useCustomContext } from "../../UIElements/CustomComponents/CustomComponents";
import { FaHome } from "react-icons/fa";
import { FaUserGroup } from "react-icons/fa6";
import { IoMdNotifications } from "react-icons/io";
import { CgDetailsMore } from "react-icons/cg";
import './Navbar.css';
import { FaBook } from "react-icons/fa";
import { insertLog } from "../Logs/InsertLog";
import { LuLogs } from "react-icons/lu";
import { MdDataset } from "react-icons/md";
import { SiDictionarydotcom } from "react-icons/si";
import { IoBookSharp, IoTicketOutline } from "react-icons/io5";
import { FaDatabase } from "react-icons/fa"; // or any icon you want
import { IoTicketSharp } from "react-icons/io5";
import { IoMdCall } from "react-icons/io";
import { MdOutlineContactPage } from "react-icons/md";
import { TbGitPullRequest } from "react-icons/tb";
import { VscGitPullRequestGoToChanges } from "react-icons/vsc";
import { FiUpload } from "react-icons/fi";


const Navbar = ({ username, onSignout }) => {
  const [expanded, setExpanded] = useState(true);
  const [isIconsOnly, setIsIconsOnly] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const folderMatch = matchPath('/details', location.pathname);
  const { showAlert, stopHudRotation, hud } = useCustomContext();

  const handleMenu = () => {
    setIsIconsOnly((prev) => !prev);
  };
  const accessLevel = parseInt(localStorage.getItem('accessLevel'), 10);
  const UserStatus = localStorage.getItem("UserStatus");
  const useremail = localStorage.getItem("email");
  const userName = useremail?.split('@')[0];
  // Check if current path matches the folder route

  const Logout = () => {
    // Keys to keep
    const keysToKeep = ['rememberMe', 'rememberedEmail', 'rememberedPassword'];

    showAlert('Are you sure you want to logout?', [
      {
        label: 'Yes',
        onClick: async () => {
          try {
            await insertLog(
              `${userName} successfully logged out`,
              0,
              useremail,
              hud,
              stopHudRotation,
              showAlert,
              '',
              'GET',
              'Logout',
              'SUCCESS',
              ''
            );

            onSignout();     // Call sign out after logging is done
            navigate('/');   // Redirect after signout
          } catch (error) {
            console.error('Failed to insert logout log:', error);
            showAlert('Logout log failed. Still signing out for safety.', [
              { label: 'Ok', color: 'var(--buttonColor)' }
            ]);
            onSignout();
            navigate('/');
          }
          Object.keys(localStorage).forEach((key) => {
            if (!keysToKeep.includes(key)) {
              localStorage.removeItem(key);
            }
          });


        },
        color: 'var(--buttonColor)', // Set button color
      },
      {
        label: 'No',
        onClick: () => {
          // console.log('User cancelled logout');
        },
        color: 'gray', // Set button color
      }
    ]);

  };


  return (
    <>
      <div className={`sidebar ${isIconsOnly ? 'icons-only' : ''}`}>
        <div className='headingandhamburger'>
          {!isIconsOnly && <span className='organizationname'>{process.env.REACT_APP_NAME}</span>}
          <span className='hamburger' onClick={handleMenu}><HiMenu size={27} /></span>
        </div>
        <ul className='navbar-list'>
          {/* <li className='navbar-list-item'>
            <NavLink to="/Home" className="menu">
              <FaHome className="icon" size={17} /> {!isIconsOnly && <span className='menu-text'>Home</span>}
            </NavLink>
          </li> */}
          <li className='navbar-list-item'>
            <NavLink to="/Datasets" className="menu">
              <MdDataset className="icon" size={17} />
              {!isIconsOnly && <span className='menu-text'>Datasets</span>}
            </NavLink>
          </li>
          {/* <li className='navbar-list-item'>
            <NavLink to="/AddSchema" className="menu">
              <MdDataset className="icon" size={17} />
              {!isIconsOnly && <span className='menu-text'>AddSchema</span>}
            </NavLink>
          </li> */}
          <li className="navbar-list-item">
            <NavLink
              to="/Agencies"
              className={() => {
                // use useLocation() value (already declared above)
                const path = (location && location.pathname) ? location.pathname : "";

                // list all paths that should keep "Agencies" active
                const activePaths = [
                  "/Agencies",
                  "/add-agencyDetails",
                  // add more child routes if needed, e.g. "/Agencies/edit", "/Agencies/view"
                ];

                // normalize: compare startsWith to allow params or trailing slashes
                const isChild = activePaths.some(p => path.startsWith(p));

                return isChild ? "menu active" : "menu";
              }}
            >
              <FaUserGroup className="icon" />
              {!isIconsOnly && <span className="menu-text">Agencies</span>}
            </NavLink>
          </li>

          {location.pathname.includes("/AgencyDetailPage") && <li className='navbar-list-sub-item'>
            <NavLink
              to="/AgencyDetailPage"
              className="sub-menu" >
              <MdOutlineContactPage className="icon" />{!isIconsOnly && <span className='menu-text'>Agency Details</span>}
            </NavLink>
          </li>}

          <li className='navbar-list-item'>
            <NavLink
              to="/RequestSentDetails"
              className={() => {
                const path = location?.pathname || "";
                const activePaths = ["/RequestSentDetails", "/RequestDetail"];
                const isActive = activePaths.some(p => path.startsWith(p));
                return isActive ? "menu active" : "menu";
              }}
            >
              <MdDataset className="icon" />
              {!isIconsOnly && <span className='menu-text'>Winter Soldier Outgoing Request</span>}
            </NavLink>
          </li>

          <li className='navbar-list-item'>
            <NavLink to="/AgenctTicketHistory"
              className={() => {
                const path = location?.pathname || "";
                const activePaths = ["/AgenctTicketHistory", "/TicketDetails"];
                const isActive = activePaths.some(p => path.startsWith(p));
                return isActive ? "menu active" : "menu";
              }}>
              <IoTicketSharp className="icon" />
              {!isIconsOnly && <span className='menu-text'>Agency Ticket History</span>}
            </NavLink>
          </li>


          {folderMatch && (
            <li className='navbar-list-item'>
              <NavLink to="/details" className="menu" style={{ marginLeft: '20px' }}>
                <CgDetailsMore className="icon" /> {!isIconsOnly && <span className='menu-text'>Details</span>}
              </NavLink>
            </li>
          )}

          <li className='navbar-list-item'>
            <NavLink to="/requestopra" className="menu">
              <VscGitPullRequestGoToChanges className="icon" size={17} />
              {!isIconsOnly && <span className='menu-text'>Request OPRA</span>}
            </NavLink>
          </li>

          {accessLevel == 1 &&
            (
              <>
                <li className='navbar-list-item'>
                  <NavLink
                    to="/Ck_Dictionary"
                    className={location.pathname.includes('/Ck_Dictionary') || location.pathname.includes("Add_CkDictionary") ? "menu active" : "menu"}
                  >
                    <IoBookSharp className="icon" />{!isIconsOnly && <span className='menu-text'>CK Dictionary</span>}
                  </NavLink>
                </li>
              </>
            )}

          {accessLevel == 1 &&
            (
              <>
                <li className='navbar-list-item'>
                  <NavLink
                    to="/Ck_Schemas"
                    className={location.pathname.includes('/Ck_Schemas') || location.pathname.includes("AddSchema") ? "menu active" : "menu"}
                  >
                    <FaBook className="icon" />{!isIconsOnly && <span className='menu-text'>CK Schemas</span>}
                  </NavLink>
                </li>
              </>
            )}

          {accessLevel == 1 &&
            (
              <>
                <li className='navbar-list-item'>
                  <NavLink to="/DocketDetails" className="menu">
                    <FaDatabase className="icon" />
                    {!isIconsOnly && <span className='menu-text'>Docket Details</span>}
                  </NavLink>
                </li>
              </>
            )}

          <li className='navbar-list-item'>
            <NavLink to="/FileUploadPage" className="menu">
              <FiUpload className="icon" />
              {!isIconsOnly && <span className='menu-text'>Files Upload</span>}
            </NavLink>
          </li>

          {accessLevel == 1 &&
            (
              <>
                <li className='navbar-list-item'>
                  <NavLink
                    to="/Call_History"
                    className="menu" >
                    <IoMdCall className="icon" />{!isIconsOnly && <span className='menu-text'>Call History</span>}
                  </NavLink>
                </li>

              </>
            )}

          {accessLevel == 1 &&
            (
              <>
                <li className='navbar-list-item'>
                  <NavLink
                    to="/Users"
                    className="menu" >
                    <FaUserGroup className="icon" />{!isIconsOnly && <span className='menu-text'>Users</span>}
                  </NavLink>
                </li>

              </>
            )}



          {(accessLevel === 1 || accessLevel === 2) && (
            <li className='navbar-list-item'>
              <NavLink
                to="/Logs"
                className="menu" >
                <LuLogs className="icon" />{!isIconsOnly && <span className='menu-text'>Logs</span>}
              </NavLink>
            </li>
          )}


          <li className='navbar-list-item'>

            {(UserStatus !== 'EXTERNAL_PROVIDER') &&
              <NavLink
                to="/Settings/Profile"
                className={location.pathname.startsWith('/Settings') ? "menu active" : "menu"}
              >
                <IoMdSettings className="icon" />
                {!isIconsOnly && <span className='menu-text'>Settings</span>}
              </NavLink>
            }

          </li>

        </ul>
        <div className="sidebar-footer">
          {!isIconsOnly && (
            <div>
              <p className="user-name">{useremail}</p>
            </div>
          )}
          <button className="bottom-logout" onClick={Logout}>
            <RiLogoutCircleRLine size={18} className={!isIconsOnly ? "mr-2" : ""} />

            {!isIconsOnly && <span className="menu-text">Logout</span>}
          </button>
        </div>
      </div >

    </>
  );
}

export default Navbar;
